import styled from '@emotion/styled';
import colorUtils from 'color';
import { tint, borderWidth } from 'polished';

import Columns from 'app/components/commons/Columns';
import Column from 'app/components/commons/Column';
import { hover } from 'app/utils/cssUtils';

export const TableRow = styled(Columns)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.color.white,
    borderColor: theme.color.basis6,
    borderStyle: 'solid',
    ...borderWidth(0, 0, 1, 0),
    color: theme.color.basis1,
    paddingLeft: theme.spacing.tiny,
    paddingRight: theme.spacing.tiny,
    fontSize: '0.9rem',
    height: 40,
    transition: 'background-color 0.2s'
  }),
  ({ highlight, theme }) =>
    highlight
      ? {
          backgroundColor: tint(0.5, theme.color.basis6),
          borderColor: 'rgba(0, 0, 0, 0)'
        }
      : {},
  ({ disabled, theme }) =>
    !disabled
      ? hover({
          backgroundColor: colorUtils(theme.color.white)
            .darken(0.05)
            .hex()
        })
      : {}
);

export const TableHead = styled(Columns)(
  ({ theme }) => ({
    backgroundColor: theme.color.basis6,
    borderTop: '2px solid',
    borderColor: theme.color.basis5,
    color: theme.color.basis1,
    fontSize: '0.8rem',
    paddingLeft: theme.spacing.tiny,
    paddingRight: theme.spacing.tiny,
    borderBottom: '2px solid white'
  }),
  ({ theme, hasScrollbar }) => ({
    [theme.mediaQuery.desktopAndUp]: hasScrollbar
      ? {
          paddingRight: 19 // vertical scroll bar
        }
      : {}
  })
);

export const TableCell = styled(Column)({
  verticalAlign: 'middle'
  // padding: `0 !important`
});
